import React, {Component} from 'react';
import {graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';
import _ from 'lodash';

const styles = {
  wrapper: {
    padding: 15
  },
};

function getMunicipalities(refinedCommentCounts = [], intl) {
  const foreignCount = refinedCommentCounts.reduce((acc, item) => {
    return item.type === 'country' && item.comment !== 'Sweden' ? acc + item.count : acc;
  }, 0);
  const countyCount = refinedCommentCounts.reduce((acc, item) => {
    return item.type === 'county' ? acc + item.count : acc;
  }, 0);
  const muniCounts = refinedCommentCounts
    .filter(item => item.type === 'municipality' || item.comment === 'Sweden');
  const counts = [
    ...muniCounts,
    {
      comment: intl.formatMessage({id: 'foreignVisitors'}),
      count: foreignCount,
    },
  ];
  const sortedCounts = _.orderBy(counts, ['count', 'comment'], ['desc', 'asc']);
  const topCounts = sortedCounts.reduce((arr, item, i) => {
    if (i <= 25) {
      return [...arr, item];
    } else if (i === 26) {
      arr[arr.length-1] = {
        comment: intl.formatMessage({id: 'other'}),
        count: arr[arr.length-1].count + countyCount + item.count,
      };
      return arr;
    } else {
      arr[arr.length-1] = {
        comment: intl.formatMessage({id: 'other'}),
        count: arr[arr.length-1].count + item.count,
      };
      return arr;
    }
  }, []);
  return topCounts;
}

function getPercentages(arr) {
  if (!arr) {
    return [];
  }
  const sum = arr.reduce(((acc, opt) => acc + opt.count), 0);
  return arr.map(opt => Math.round((opt.count/sum)*1000)/10);
}

@injectIntl
@withReportFilterProps
@withWidgetData(
  graphql`
    query MunicipalitiesWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
            ) {
              refinedCommentCounts {
                comment
                type
                count
              }
              count
            }
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter({hideFooter: true})
class MunicipalitiesWidget extends Component {
  render() {
    const widget = this.props.widget;
    const question = widget.config.question;

    const intl = this.props.intl;
    const answersReport = question.answersReport;
    const refinedCommentCounts = answersReport ? answersReport.refinedCommentCounts : [];
    const municipalities = getMunicipalities(refinedCommentCounts, intl);
    const categories = _.map(municipalities, 'comment');
    const data = getPercentages(municipalities);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.bodyHeight-(styles.wrapper.padding*2)-20,
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: null,
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: municipalities[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y}%'
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };

    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: widget.id}}
        />
      </div>
    );
  }
}

export default MunicipalitiesWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/MunicipalitiesWidget/MunicipalitiesWidget.js